import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Showcase, SectionTitle } from '../../../../components'

import data from './data.json'
import modalImage from '../../../../images/wt-modal.png'
// import scrollableImage from '../../../../images/wt-scrollable.png'
import scrollableImageSticky from '../../../../images/wt-scrollable-sticky-title.png'
import InfoAlertModal from '../../../../images/infoalertmodal.png'
import WarningAlertModal from '../../../../images/WarningAlertModal.png'
import ErrorAlertModal from '../../../../images/ErrorAlertModal.png'

export default props => {
  const code = {
    scrollable: `<div class="p-modal__overlay" id="scrollable" >
    <div class="p-modal" >
      <div class="p-modal__close-bar p-modal__close-bar--scroll">
        <h1 class="p-modal__close-bar-title">Header</h1>
        <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i> </button>
      </div>
      <div class="p-modal__content">
        Content Section
          <p class="l-margin-bottom--none">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pulvinar laoreet ligula in placerat. Quisque sed lacinia nulla. Nullam nec nulla nec tortor suscipit ullamcorper. Pellentesque dui dolor, varius sodales dolor sed, bibendum eleifend lorem. Maecenas ut dui quis lacus volutpat eleifend maximus a nisi. Curabitur lobortis elementum risus nec tincidunt. Nunc at libero porta, pretium velit non, interdum felis. Maecenas eget nulla accumsan, suscipit justo at, facilisis turpis. Pellentesque mattis justo eu tellus tempor posuere. Duis dignissim justo et magna congue, ut tincidunt erat sollicitudin. Pellentesque maximus pulvinar vestibulum. Aliquam erat volutpat. Nulla lobortis ante a hendrerit lacinia. Phasellus non efficitur nisl, eu malesuada ante. Nunc gravida eros vel sapien egestas, ac pellentesque urna fermentum. Nulla vitae ligula vel enim auctor ornare.

        Donec sit amet pharetra purus. Nunc lesuada arcu congue sit amet. Ut tempus ex et turpis auctor, id hendrerit felis volutpat. Curabitur elementum lacinia malesuada. Curabitur sed condimentum mauris. Fusce molestie, metus vel aliquet porta, odio lorem molestie ligula, sed vehicula risus tortor et justo. Nunc elementum libero eu condimentum scelerisque. Vestibulum tincidunt justo risus, nec gravida diam tempor sit amet. Vestibulum ultrices diam semper risus lobortis, a sodales metus accumsan. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
      </div>
      <div class="p-modal__footer p-modal__footer--shadow">
        <button class="p-modal__button">Button</button>
        <button class="p-modal__button--primary">Primary</button>
      </div>
    </div>
  </div>`,
    scrollableSticky: `<div class="p-modal__overlay" id="scrollable" >
    <div class="p-modal" >
      <div class="p-modal__close-bar">
        <h1 class="p-modal__close-bar-title">Header</h1>
        <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i> </button>
      </div>
      <div class="p-modal__sub-title">Optional sticky subtitle</div>
      <div class="p-modal__content">
        Content Section
          <p class="l-margin-bottom--none">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam pulvinar laoreet ligula in placerat. Quisque sed lacinia nulla. Nullam nec nulla nec tortor suscipit ullamcorper. Pellentesque dui dolor, varius sodales dolor sed, bibendum eleifend lorem. Maecenas ut dui quis lacus volutpat eleifend maximus a nisi. Curabitur lobortis elementum risus nec tincidunt. Nunc at libero porta, pretium velit non, interdum felis. Maecenas eget nulla accumsan, suscipit justo at, facilisis turpis. Pellentesque mattis justo eu tellus tempor posuere. Duis dignissim justo et magna congue, ut tincidunt erat sollicitudin. Pellentesque maximus pulvinar vestibulum. Aliquam erat volutpat. Nulla lobortis ante a hendrerit lacinia. Phasellus non efficitur nisl, eu malesuada ante. Nunc gravida eros vel sapien egestas, ac pellentesque urna fermentum. Nulla vitae ligula vel enim auctor ornare.

        Donec sit amet pharetra purus. Nunc lesuada arcu congue sit amet. Ut tempus ex et turpis auctor, id hendrerit felis volutpat. Curabitur elementum lacinia malesuada. Curabitur sed condimentum mauris. Fusce molestie, metus vel aliquet porta, odio lorem molestie ligula, sed vehicula risus tortor et justo. Nunc elementum libero eu condimentum scelerisque. Vestibulum tincidunt justo risus, nec gravida diam tempor sit amet. Vestibulum ultrices diam semper risus lobortis, a sodales metus accumsan. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
      </div>
      <div class="p-modal__footer p-modal__footer--shadow">
        <button class="p-modal__button">Button</button>
        <button class="p-modal__button--primary">Primary</button>
      </div>
    </div>
  </div>`,
    notScrollable: `
    <div class="p-modal__overlay">
      <div class="p-modal">
        <div class="p-modal__close-bar">
          <h1 class="p-modal__close-bar-title">Header</h1>
          <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i> </button>
        </div>
        <div class="p-modal__content">
          Content Section
            <p class="l-margin-bottom--none">Lorem ipsum dolor</p>
        </div>
        <div class="p-modal__footer">
          <button class="p-modal__button">Button</button>
          <button class="p-modal__button--primary">Primary</button>
        </div>
      </div>
    </div>`,
    infoAlert: `
    <div class="p-modal__overlay">
      <div class="p-modal-alert">
        <div class="p-modal-alert__close-bar">
          <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i></button>
        </div>
        <div class="p-modal-alert__content">
          <i class='icon icon--exclamation p-modal-alert__icon u-color--semantic-orange-base'></i>
          <div class="p-modal-alert__title">Are you sure you want to delete this address?</div>
          <hr class="p-modal-alert__divider"/>      
          <div class="p-modal-alert__text">123 Park Ave Ormond Beach, FL 38477</div>
        </div>
        <div class="p-modal__footer">          
          <button class="p-modal__button--primary">Call Us</button>
        </div>
      </div>
    </div>`,
    warningAlert: `
    <div class="p-modal__overlay">
      <div class="p-modal-alert">
        <div class="p-modal-alert__close-bar">
          <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i></button>
        </div>
        <div class="p-modal-alert__content">
          <i class='icon icon--info p-modal-alert__icon u-color--primary-base'></i>
          <div class="p-modal-alert__title">Need help?</div>
          <hr class="p-modal-alert__divider"/>      
          <div class="p-modal-alert__text">If you're stuck, call one of our help desk representatives to
          assist you in the process.</div>
        </div>
        <div class="p-modal__footer">
          <button class="p-modal__button">Cancel</button>
          <button class="p-modal__button--primary">Confirm</button>
        </div>
      </div>
    </div>`,
    errorAlert: `
    <div class="p-modal__overlay">
      <div class="p-modal-alert">
        <div class="p-modal-alert__close-bar">
          <button class="p-modal__close-bar-button" ><i class="icon icon--close p-modal__close-bar-button-icon"></i></button>
        </div>
        <div class="p-modal-alert__content">
          <i class='icon icon--error p-modal-alert__icon u-color--semantic-red-base'></i>
          <div class="p-modal-alert__title">Your account has been locked</div>
          <hr class="p-modal-alert__divider"/>      
          <div class="p-modal-alert__text">You have made too many failed login attempts. Please contact
          one of our help desk representatives for assistance.</div>
        </div>        
      </div>
    </div>`,
  }

  const toggleDefault = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('modal').classList.toggle('u-is-hidden')
  }

  // const toggleScrollable = () => {
  //   document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
  //   document.getElementById('scrollable').classList.toggle('u-is-hidden')
  // }

  const toggleScrollableSticky = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('scrollable-sticky').classList.toggle('u-is-hidden')
  }

  const toggleInfoAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('InfoAlert').classList.toggle('u-is-hidden')
  }
  const toggleWarningAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('WarningAlert').classList.toggle('u-is-hidden')
  }
  const toggleErrorAlert = () => {
    document.getElementsByTagName('body')[0].classList.toggle('u-scroll--none')
    document.getElementById('ErrorAlert').classList.toggle('u-is-hidden')
  }

  //avoid activating toggle method when clicking in the modal
  const avoidPropagation = e => {
    e.stopPropagation()
  }

  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <div class="intro">
          <p>
            Modals present contextual information or tasks without navigating
            the user away from the main task flow. Because they sit on an
            elevated layer and disable the layout behind them, they should be
            used for tasks and alerts that require the user's exclusive
            attention.
          </p>
        </div>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Standard Modal"
          text={
            <p>
              Standard modals allow the user to review information or take
              action. The required parts are a title, plain or rich-text body
              content and associated actions. A standard modal may also have a
              sub-header and a Close icon.
            </p>
          }
          code={code.notScrollable}
        >
          <img
            class="l-margin-top--large"
            src={modalImage}
            width="100%"
            alt="Screenshot of modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="modal"
            onClick={toggleDefault}
            onKeyDown={toggleDefault}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal__close-bar">
                <h1 class="p-modal__close-bar-title">Header</h1>
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleDefault}
                  onKeyDown={toggleDefault}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal__content">
                Content Section
                <p class="l-margin-bottom--none">Lorem ipsum dolor</p>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button">Button</button>
                <button class="p-modal__button--primary">Primary</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleDefault}
            onKeyDown={toggleDefault}
          >
            Open a Standard Modal{' '}
          </button>
        </Showcase>
        <h3>Alert Modal</h3>
        <p>
          Alert modals interrupt or end a user's task flow to give critical
          feedback or force an immediate action. The required elements are a
          feedback icon, a title, body content and a way to dismiss the modal.
        </p>
        <Showcase
          site={data.site}
          title="Information Alert Modal"
          text="Use information alert modals to direct the user on how to continue an interaction outside of the designed experience."
          code={code.infoAlert}
        >
          <img
            class="l-margin-top--large"
            src={InfoAlertModal}
            width="100%"
            alt="Screenshot of info alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="InfoAlert"
            onClick={toggleInfoAlert}
            onKeyDown={toggleInfoAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleInfoAlert}
                  onKeyDown={toggleInfoAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--info p-modal-alert__icon u-color--primary-base"></i>
                <div class="p-modal-alert__title">Need help?</div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  If you're stuck, call one of our help desk representatives to
                  assist you in the process.
                </div>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button--primary">Call Us</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleInfoAlert}
            onKeyDown={toggleInfoAlert}
          >
            Open an Info Alert Modal{' '}
          </button>
        </Showcase>
        <Showcase
          site={data.site}
          title="Warning Alert Modal"
          text={
            <p>
              Use warning alert modals to warn of destructive action and ask for
              immediate user confirmation in instances where the action will
              lead to data loss. If warning feedback does not require user
              confirmation, use the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/notifications/develop'}
              >
                Notifcation
              </Link>{' '}
              component instead.
            </p>
          }
          code={code.warningAlert}
        >
          <img
            class="l-margin-top--large"
            src={WarningAlertModal}
            width="100%"
            alt="Screenshot of warning alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="WarningAlert"
            onClick={toggleWarningAlert}
            onKeyDown={toggleWarningAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleWarningAlert}
                  onKeyDown={toggleWarningAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--exclamation p-modal-alert__icon u-color--semantic-orange-base"></i>
                <div class="p-modal-alert__title">
                  Are you sure you want to delete this address?
                </div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  123 Park Ave Ormond Beach, FL 38477
                </div>
              </div>
              <div class="p-modal__footer">
                <button class="p-modal__button">Cancel</button>
                <button class="p-modal__button--primary">Confirm</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleWarningAlert}
            onKeyDown={toggleWarningAlert}
          >
            Open a Warning Alert Modal{' '}
          </button>
        </Showcase>
        <Showcase
          site={data.site}
          title="Error Alert Modal"
          text={
            <p>
              Use error alert modals to tell the user of an error that they
              cannot resolve on their own. Provide information within the body
              on how to proceed. If warning feedback is related to an action on
              the underlying page and can be fixed there, use the{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/notifications/develop'}
              >
                Notifcation
              </Link>{' '}
              or{' '}
              <Link
                class="link"
                to={'/' + data.site + '/components/inline-error/develop'}
              >
                Inline Error
              </Link>{' '}
              components instead. To communicate a system error, use a full-page
              error layout.
            </p>
          }
          code={code.errorAlert}
        >
          <img
            class="l-margin-top--large"
            src={ErrorAlertModal}
            width="100%"
            alt="Screenshot of warning alert modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="ErrorAlert"
            onClick={toggleErrorAlert}
            onKeyDown={toggleErrorAlert}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal-alert"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal-alert__close-bar">
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleErrorAlert}
                  onKeyDown={toggleErrorAlert}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal-alert__content">
                <i class="icon icon--error p-modal-alert__icon u-color--semantic-red-base"></i>
                <div class="p-modal-alert__title">
                  Your account has been locked
                </div>
                <hr class="p-modal-alert__divider" />
                <div class="p-modal-alert__text">
                  You have made too many failed login attempts. Please contact
                  one of our help desk representatives for assistance.
                </div>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleErrorAlert}
            onKeyDown={toggleErrorAlert}
          >
            Open an Error Alert Modal{' '}
          </button>
        </Showcase>
        <SectionTitle>States</SectionTitle>
        <Showcase
          site={data.site}
          title="Scroll"
          text="In addition to the default state, which indicates that a modal is in the top scroll position or there is no scrollable content, Standard Modals with lengthy body content can use a scroll state. When scrolling, the header and optional sub-header, as well as the footer bar, will elevate and remain persistent at the top of the container with the rest of the content scrolling behind."
          code={code.scrollableSticky}
        >
          <img
            src={scrollableImageSticky}
            width="100%"
            alt="Screenshot of modal component."
          />
          <div
            class="p-modal__overlay u-is-hidden"
            id="scrollable-sticky"
            onClick={toggleScrollableSticky}
            onKeyDown={toggleScrollableSticky}
            role="button"
            tabIndex={0}
          >
            <div
              class="p-modal"
              onClick={avoidPropagation}
              onKeyDown={avoidPropagation}
              role="button"
              tabIndex={0}
            >
              <div class="p-modal__close-bar">
                <h1 class="p-modal__close-bar-title">Header</h1>
                <button
                  class="p-modal__close-bar-button"
                  onClick={toggleScrollableSticky}
                  onKeyDown={toggleScrollableSticky}
                >
                  <i class="icon icon--close p-modal__close-bar-button-icon"></i>{' '}
                </button>
              </div>
              <div class="p-modal__sub-title">Optional sticky subtitle</div>
              <div class="p-modal__content">
                Content Section
                <p class="l-margin-bottom--none">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Nullam pulvinar laoreet ligula in placerat. Quisque sed
                  lacinia nulla. Nullam nec nulla nec tortor suscipit
                  ullamcorper. Pellentesque dui dolor, varius sodales dolor sed,
                  bibendum eleifend lorem. Maecenas ut dui quis lacus volutpat
                  eleifend maximus a nisi. Curabitur lobortis elementum risus
                  nec tincidunt. Nunc at libero porta, pretium velit non,
                  interdum felis. Maecenas eget nulla accumsan, suscipit justo
                  at, facilisis turpis. Pellentesque mattis justo eu tellus
                  tempor posuere. Duis dignissim justo et magna congue, ut
                  tincidunt erat sollicitudin. Pellentesque maximus pulvinar
                  vestibulum. Aliquam erat volutpat. Nulla lobortis ante a
                  hendrerit lacinia. Phasellus non efficitur nisl, eu malesuada
                  ante. Nunc gravida eros vel sapien egestas, ac pellentesque
                  urna fermentum. Nulla vitae ligula vel enim auctor ornare.
                  Donec sit amet pharetra purus. Nunc lesuada arcu congue sit
                  amet. Ut tempus ex et turpis auctor, id hendrerit felis
                  volutpat. Curabitur elementum lacinia malesuada. Curabitur sed
                  condimentum mauris. Fusce molestie, metus vel aliquet porta,
                  odio lorem molestie ligula, sed vehicula risus tortor et
                  justo. Nunc elementum libero eu condimentum scelerisque.
                  Vestibulum tincidunt justo risus, nec gravida diam tempor sit
                  amet. Vestibulum ultrices diam semper risus lobortis, a
                  sodales metus accumsan. Pellentesque habitant morbi tristique
                  senectus et netus et malesuada fames ac turpis egestas.
                  Vestibulum diam erat, tempus sit amet scelerisque et, vehicula
                  non metus. Curabitur tincidunt id lorem non porta. In sed
                  neque a odio fermentum pharetra eu sed neque. Cras justo
                  tortor, aliquam at metus eget, tincidunt hendrerit odio. Lorem
                  ipsum dolor sit amet, consectetur adipiscing elit. Nullam
                  pulvinar laoreet ligula in placerat. Quisque sed lacinia
                  nulla. Nullam nec nulla nec tortor suscipit ullamcorper.
                  Pellentesque dui dolor, varius sodales dolor sed, bibendum
                  eleifend lorem. Maecenas ut dui quis lacus volutpat eleifend
                  maximus a nisi. Curabitur lobortis elementum risus nec
                  tincidunt. Nunc at libero porta, pretium velit non, interdum
                  felis. Maecenas eget nulla accumsan, suscipit justo at,
                  facilisis turpis. Pellentesque mattis justo eu tellus tempor
                  posuere. Duis dignissim justo et magna congue, ut tincidunt
                  erat sollicitudin. Pellentesque maximus pulvinar vestibulum.
                  Aliquam erat volutpat. Nulla lobortis ante a hendrerit
                  lacinia. Phasellus non efficitur nisl, eu malesuada ante. Nunc
                  gravida eros vel sapien egestas, ac pellentesque urna
                  fermentum. Nulla vitae ligula vel enim auctor ornare. Donec
                  sit amet pharetra purus. Nunc lesuada arcu congue sit amet. Ut
                  tempus ex et turpis auctor, id hendrerit felis volutpat.
                  Curabitur elementum lacinia malesuada. Curabitur sed
                  condimentum mauris. Fusce molestie, metus vel aliquet porta,
                  odio lorem molestie ligula, sed vehicula risus tortor et
                  justo. Nunc elementum libero eu condimentum scelerisque.
                  Vestibulum tincidunt justo risus, nec gravida diam tempor sit
                  amet. Vestibulum ultrices diam semper risus lobortis, a
                  sodales metus accumsan. Pellentesque habitant morbi tristique
                  senectus et netus et malesuada fames ac turpis egestas.
                  Vestibulum diam erat, tempus sit amet scelerisque et, vehicula
                  non metus. Curabitur tincidunt id lorem non porta. In sed
                  neque a odio fermentum pharetra eu sed neque. Cras justo
                  tortor, aliquam at metus eget, tincidunt hendrerit odio. Lorem
                  ipsum dolor sit amet, consectetur adipiscing elit. Nullam
                  pulvinar laoreet ligula in placerat. Quisque sed lacinia
                  nulla. Nullam nec nulla nec tortor suscipit ullamcorper.
                  Pellentesque dui dolor, varius sodales dolor sed, bibendum
                  eleifend lorem. Maecenas ut dui quis lacus volutpat eleifend
                  maximus a nisi. Curabitur lobortis elementum risus nec
                  tincidunt. Nunc at libero porta, pretium velit non, interdum
                  felis. Maecenas eget nulla accumsan, suscipit justo at,
                  facilisis turpis. Pellentesque mattis justo eu tellus tempor
                  posuere. Duis dignissim justo et magna congue, ut tincidunt
                  erat sollicitudin. Pellentesque maximus pulvinar vestibulum.
                  Aliquam erat volutpat. Nulla lobortis ante a hendrerit
                  lacinia. Phasellus non efficitur nisl, eu malesuada ante. Nunc
                  gravida eros vel sapien egestas, ac pellentesque urna
                  fermentum. Nulla vitae ligula vel enim auctor ornare. Donec
                  sit amet pharetra purus. Nunc lesuada arcu congue sit amet. Ut
                  tempus ex et turpis auctor, id hendrerit felis volutpat.
                  Curabitur elementum lacinia malesuada. Curabitur sed
                  condimentum mauris. Fusce molestie, metus vel aliquet porta,
                  odio lorem molestie ligula, sed vehicula risus tortor et
                  justo. Nunc elementum libero eu condimentum scelerisque.
                  Vestibulum tincidunt justo risus, nec gravida diam tempor sit
                  amet. Vestibulum ultrices diam semper risus lobortis, a
                  sodales metus accumsan. Pellentesque habitant morbi tristique
                  senectus et netus et malesuada fames ac turpis egestas.
                  Vestibulum diam erat, tempus sit amet scelerisque et, vehicula
                  non metus. Curabitur tincidunt id lorem non porta. In sed
                  neque a odio fermentum pharetra eu sed neque. Cras justo
                  tortor, aliquam at metus eget, tincidunt hendrerit odio.
                </p>
              </div>
              <div class="p-modal__footer p-modal__footer--shadow">
                <button class="p-modal__button">Button</button>
                <button class="p-modal__button--primary">Primary</button>
              </div>
            </div>
          </div>
          <button
            class="c-link l-margin-top--large"
            onClick={toggleScrollableSticky}
            onKeyDown={toggleScrollableSticky}
          >
            Open a Modal in Scroll State{' '}
          </button>
        </Showcase>
        <hr />
        <SectionTitle>Accessibility</SectionTitle>
        <p>
          Use <span class="inline__code">role="dialog"</span> and{' '}
          <span class="inline__code">aria-modal="true"</span> to convey to
          assistive technology that the modal content is separate from the rest
          of the page. Toggle on{' '}
          <span class="inline__code">aria-hidden="true"</span> on the underlying
          content when the modal is open to trap keyboard focus. To be
          completely accessible, label the same element that carries the role
          attribute with a corresponding id attribute on the modal title.
        </p>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        At larger breakpoints, modals take up 70% of the screen width, with a
        max-width of 710px. Modals can be dismissed by clicking the scrim
        outside of the modal container, pressing the escape key, clicking the
        close icon or any dismissing action included in the modal. Modals should
        never trigger other modals.
      </Layout>
    </>
  )
}
